import { logger } from '../../../utils/logger'
import { setJsonSessionItem } from '../../../utils/session-storage'
import type { ServiceHandler } from './service-registry'
import { getSessionStorageCustomQuestionsKey } from './setCustomQuestionAnswer'
import type {
  ClearDonorQuestionAnswersRequest,
  ClearDonorQuestionAnswersResponse,
} from '@custom-embedded-code-sdk/methods/donor-questions'

/**
 * CLEAR_CUSTOM_QUESTION_ANSWERS service handler
 *
 * Handles requests to remove all Custom Question answers for the current campaign.
 * Replaces the session storage key `custom_questions_{campaignId}` with a new empty object.
 */
export const clearCustomQuestionAnswers: ServiceHandler<
  ClearDonorQuestionAnswersRequest,
  ClearDonorQuestionAnswersResponse
> = async ({ iframeId, messageId, sendSuccessResponse, sendErrorResponse, pageConfig }) => {
  const campaignId = pageConfig.campaignId

  try {
    if (!campaignId) {
      throw new Error('CustomEmbeddedCode:clearCustomQuestionAnswers: Campaign ID not available')
    }

    const storageKey = getSessionStorageCustomQuestionsKey(campaignId)
    setJsonSessionItem(storageKey, {})

    logger(
      'info',
      'CustomEmbeddedCode:clearCustomQuestionAnswers: All Custom Question answers cleared successfully',
      {
        context: { iframeId, messageId, campaignId, storageKey },
      },
    )

    sendSuccessResponse(iframeId, messageId, { success: true })
  } catch (error) {
    logger(
      'error',
      new Error(
        'CustomEmbeddedCode:clearCustomQuestionAnswers: Failed to clear Custom Question answers',
        {
          cause: error,
        },
      ),
      {
        context: { iframeId, messageId, campaignId },
      },
    )
    sendErrorResponse(iframeId, messageId, 'Unable to clear Custom Question answers')
  }
}
